<template>
    <div>

        <div v-if="day.type == 'next'" tabindex="0"
            role="gridcell" :aria-label="full_date(day.date)"
            class="border-r-2 p-color last-td-background shadow-lg pb-16 td-width align-top relative box-hover">
            <div class="flex lg:flex-nowrap pl-2 py-2">
                <h3 class="week-cycle-fontsize week-cycle-color font-bold pr-6">
                    {{ format_date(day.date) }}
                </h3>
            </div>

            <div v-if="products.length == 0" class="flex justify-center flex-col items-center w-full -ml-2 mt-5">
                <!-- <img src="/vendor/nutristudents/image/not-in-session.png" alt=""> -->
                <span class="italic text-xs mt-1">Not Available!</span>
            </div>

            <div class="color-24 text-sm block pl-2"
                v-if="products.length > 0 && isShowMenu(day) && verifyExcludeDay(day.date) === false">
            <ul>
                <li v-for="product in products"> {{ getPhotoStorePath(product) }}</li>
            </ul>
            </div>

            <span v-if="verifyExcludeDay(day.date) === true"
                class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in session!</span>
        </div>

        <div v-else class="border-r-2 p-color shadow-lg pb-16 td-width align-top relative box-hover focus:ring-2 focus:ring-[#38558e] outline-none"
            :class="(((moment().isBefore(day.date) === false) && (moment().format('MM-DD-YYYY') != day.date)) || verifyExcludeDay(day.date) === true) ? 'bg-grey' : 'bg-white'"
            tabindex="0" role="gridcell" :aria-describedby="'date-' + day.date">

            <div class="flex lg:flex-nowrap pl-2 py-2">
                <h3 :id="'date-' + day.date" class="week-cycle-fontsize week-cycle-color font-bold pr-6">
                    {{ format_date(day.date) }} <span class="sr-only">{{ full_date(day.date) }}</span> &nbsp;
                    <!-- <span v-if="cal_days" class="h-2 w-2 rounded-full inline-block" :class="(cal_days && (cal_days.is_guidline && cal_days.is_additional ) )?'online-background-color':'offline-background-color'"></span> -->
                </h3>
            </div>

            <div v-if="verifyExcludeDay(day.date) === false && isShowMenu(day)" class="color-24 text-sm block divl-2 w-full">

                <div v-if="products.length == 0" class="flex w-full h-full">
                    <div class="w-full h-full">
                        <img :src="$page.props.asset_url + '/images/no-food-sign2.jpg'" class="w-full h-full object-cover" alt="No food sign">
                    </div>
                </div>

                <div v-if="products.length == 1" class="flex w-full h-full mh-135 relative box-type-show">
                    <div v-for="(product, index) in products" class="w-full h-full">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="'Image for ' + getOptionName(product)">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'"
                            class="w-full h-full object-cover" :alt="'Image for ' + getOptionName(product)">
                        <span class="w-full text-black text-base uppercase option_title">{{ getOptionName(product) }}</span>
                        <div v-if="product.recipes && product.recipes.length > 0" class="w-full h-full pl-4 space-y-1">
                            <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-label="group.category">
                                <b class="text-sm block mt-1">{{ group.category }}</b>
                                <ul>
                                    <li v-for="recipe in group.recipes" :key="recipe.id" class="text-xs">
                                        {{ recipe.show_name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4 :id="'nutritional-info-' + day.date + '-' + index" class="sr-only">Nutritional Information</h4>
                        <table v-if="product.total_val" class="w-full pl-4 border-collapse focus:ring-2 focus:ring-[#38558e] outline-none" 
                            tabindex="0" :aria-labelledby="'nutritional-info-' + day.date + '-' + index">
                            <thead class="sr-only">
                                <tr>
                                    <th scope="col">Nutrient</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Calories</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CALS, 'cals') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Sodium</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.SOD, 'mg') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Sugar</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.sugar, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Added Sugars</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.added_sugars, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.FAT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Saturated Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.satfat, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Protein</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.PROT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Carbs</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CARB, 'g') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div v-if="products.length == 2" class="flex flex-wrap h-full mh-135  relative">
                    <div v-for="(product, index) in products" class="w-full h-1/2 relative">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="getOptionName(product)">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="getOptionName(product)">
                        <span class="w-full text-black text-base uppercase option_title">{{ getOptionName(product) }}</span>
                        <div v-if="product.recipes && product.recipes.length > 0" class="w-full h-full pl-4 space-y-1">
                            <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-label="group.category">
                                <b class="text-sm block mt-1">{{ group.category }}</b>
                                <ul>
                                    <li v-for="recipe in group.recipes" :key="recipe.id" class="text-xs">
                                        {{ recipe.show_name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4 :id="'nutritional-info-' + day.date + '-' + index" class="sr-only">Nutritional Information</h4>
                        <table v-if="product.total_val" class="w-full pl-4 border-collapse focus:ring-2 focus:ring-[#38558e] outline-none" 
                            tabindex="0" :aria-labelledby="'nutritional-info-' + day.date + '-' + index">
                            <thead class="sr-only">
                                <tr>
                                    <th scope="col">Nutrient</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Calories</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CALS, 'cals') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Sodium</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.SOD, 'mg') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Sugar</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.sugar, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Added Sugars</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.added_sugars, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.FAT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Saturated Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.satfat, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Protein</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.PROT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Carbs</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CARB, 'g') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>

                <div v-if="products.length == 3" class="flex flex-wrap h-full mh-135 relative ">
                    <div v-for="(product, index) in products"
                        :class="(index == 0) ? 'w-full h-1/2 box-type-show relative' : 'w-6/12 h-1/2 box-type-show relative'">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full">
                        <span class="w-full text-black text-base uppercase option_title">{{ getOptionName(product) }}</span>
                        <div v-if="product.recipes && product.recipes.length > 0" class="w-full h-full pl-4 space-y-1">
                            <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-label="group.category">
                                <b class="text-sm block mt-1">{{ group.category }}</b>
                                <ul>
                                    <li v-for="recipe in group.recipes" :key="recipe.id" class="text-xs">
                                        {{ recipe.show_name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4 :id="'nutritional-info-3-' + day.date + '-' + index" class="sr-only">Nutritional Information</h4>
                        <table v-if="product.total_val" class="w-full pl-4 border-collapse focus:ring-2 focus:ring-[#38558e] outline-none" 
                            tabindex="0" :aria-labelledby="'nutritional-info-3-' + day.date + '-' + index">
                            <thead class="sr-only">
                                <tr>
                                    <th scope="col">Nutrient</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Calories</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CALS, 'cals') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Sodium</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.SOD, 'mg') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Sugar</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.sugar, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Added Sugars</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.added_sugars, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.FAT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Saturated Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.satfat, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Protein</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.PROT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Carbs</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CARB, 'g') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>

                <div v-if="products.length == 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full">
                        <span class="w-full text-black text-base uppercase option_title">{{ getOptionName(product) }}</span>
                        <div v-if="product.recipes && product.recipes.length > 0" class="w-full h-full pl-4 space-y-1">
                            <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-label="group.category">
                                <b class="text-sm block mt-1">{{ group.category }}</b>
                                <ul>
                                    <li v-for="recipe in group.recipes" :key="recipe.id" class="text-xs">
                                        {{ recipe.show_name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4 :id="'nutritional-info-4-' + day.date + '-' + index" class="sr-only">Nutritional Information</h4>
                        <table v-if="product.total_val" class="w-full pl-4 border-collapse focus:ring-2 focus:ring-[#38558e] outline-none" 
                            tabindex="0" :aria-labelledby="'nutritional-info-4-' + day.date + '-' + index">
                            <thead class="sr-only">
                                <tr>
                                    <th scope="col">Nutrient</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Calories</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CALS, 'cals') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Sodium</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.SOD, 'mg') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Sugar</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.sugar, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Added Sugars</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.added_sugars, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.FAT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Saturated Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.satfat, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Protein</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.PROT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Carbs</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CARB, 'g') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div v-if="products.length > 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative" v-show="index < 4">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full">
                        <span class="w-full text-black text-base uppercase option_title">{{ getOptionName(product) }}</span>
                        <div v-if="product.recipes && product.recipes.length > 0" class="w-full h-full pl-4 space-y-1">
                            <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-label="group.category">
                                <b class="text-sm block mt-1">{{ group.category }}</b>
                                <ul>
                                    <li v-for="recipe in group.recipes" :key="recipe.id" class="text-xs">
                                        {{ recipe.show_name }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4 :id="'nutritional-info-more-' + day.date + '-' + index" class="sr-only">Nutritional Information</h4>
                        <table v-if="product.total_val" class="w-full pl-4 border-collapse focus:ring-2 focus:ring-[#38558e] outline-none" 
                            tabindex="0" :aria-labelledby="'nutritional-info-more-' + day.date + '-' + index">
                            <thead class="sr-only">
                                <tr>
                                    <th scope="col">Nutrient</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Calories</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CALS, 'cals') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Sodium</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.SOD, 'mg') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Sugar</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.sugar, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Added Sugars</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.added_sugars, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Total Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.FAT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Saturated Fat</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.satfat, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Protein</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.PROT, 'g') }}</td>
                                </tr>
                                <tr class="text-xs">
                                    <th scope="row" class="font-normal text-left">Carbs</th>
                                    <td class="text-right">{{ $helpers.roundTwoDecimals(product.total_val.CARB, 'g') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>




                </div>
            </div>
            <div class="w-full absolute button-none bottom-0-space" v-if="menuCycle && cal_days">
            </div>
            <span v-if="verifyExcludeDay(day.date) === true"
                class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in session!</span>
        </div>
    </div>
</template>

<script>
var moment = require('moment');

export default {
    props: ['day', 'index', 'menuCycle', 'searchForm', 'week', 'excludeDays', 'isMenuPlanner'],
    components: {},

    data() {
        return {
            log: console.log,
            cal_days: null,
            moment: moment,
            is_assembly_instructions: false,
            cart_id_for_remove: '',
            showCartIcon: false
        }
    },
    computed: {
        products: function () {
            this.cal_days = null;
            let $this = this;
            if (this.menuCycle) {
                console.log("Menucycleview", this.menuCycle);
                let options = [];
                this.menuCycle.menu_cycle_days.forEach(mcdays => {
                    if (mcdays.day_of_week_number - 1 == $this.index) {
                        $this.is_assembly_instructions = mcdays.is_assembly_instructions;
                        options = mcdays.options;
                        $this.cal_days = mcdays;
                    }
                });

                console.log('optionssss', options);
                return options;
            } else {
                $this.is_assembly_instructions = false;
                return [];
            }
        },

    },
    methods: {

        sortArrays(arrays) {
            return _.orderBy(arrays, 'sort_order', 'asc');
        },

        format_date(value) {
            if (value) {
                let date;
                // Check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    // Safari requires the date string to be in YYYY/MM/DD format
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { day: 'numeric' };
                return date.toLocaleDateString('en-US', options);

                // return moment(String(value)).format('DD')
            }
        },

        full_date(value) {
            if (value) {
                let date;
                // Check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    // Safari requires the date string to be in YYYY/MM/DD format
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { weekday: 'long', month: 'long', day: 'numeric' };
                return date.toLocaleDateString('en-US', options);
            }
        },

        getOptionName(mc) {

            if (mc.name == '') {
                return "Option " + mc.sort_order;
            } else {
                return mc.name;
            }
        },

        getPhotoStorePath(mc) {
            if (mc.photo_store_path == '') {
                return "null";
            } else {
                return this.$page.props.storage_image_url + mc.photo_store_path;
            }
        },

        loadCalendar() {
            this.$emit('loadCalendar');
        },
        loadExcludedDateDataOnLoad(site, guide_line_id) {
            this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
        },

        verifyExcludeDay(current_date) {
            // console.log('excludeDays', current_date);
            if (this.excludeDays) {
                // var new_date = moment(current_date).format('MM/DD/YYYY');
                var new_date = moment(current_date, 'MM-DD-YYYY').format('MM/DD/YYYY');
                let obj = this.excludeDays.find(o => o.date === new_date);
                if (obj) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;

        },

        isShowMenu(cday) {
            return true;
        },

        groupRecipesByCategory(recipes) {
            if (!recipes) return [];
            let sorted = _.orderBy(recipes, 'name', 'asc');
            sorted = _.orderBy(sorted, 'category_sort', 'asc');

            const groups = [];
            let currentGroup = null;
            sorted.forEach(recipe => {
                if (!currentGroup || currentGroup.category !== recipe.category) {
                    currentGroup = { category: recipe.category, recipes: [] };
                    groups.push(currentGroup);
                }
                currentGroup.recipes.push(recipe);
            });
            return groups;
        }

    }
};
</script>

<style scoped>
/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style>
.font-24 {
    font-size: 24px;
}

.color-24 {
    color: #636363;
}

.p-color {
    color: #969696;
}

.p-size {
    font-size: 15px;
}

.online-color {
    color: #22af4b;
}

.offline-color {
    color: #cb0000;
}

.number-background-color {
    background-color: #cb0000;
}

.online-background-color {
    background-color: #22af4b;
}

.week-cycle-color {
    color: #1c2a47;
}

.week-cycle-fontsize {
    font-size: 14px;
}

.three-dot-color {
    color: #38558e;
}

.table-background {
    background-color: #f3f3f3;
}

.last-td-background {
    background-color: #f5f5f5;
}

.td-width {
    width: 14.28%;
    min-height: 135px;
    min-width: 170px;
}

.td-width .absolute-div {
    left: 35px;
}

.cart-color {
    color: #f7a53a;
}

.plus-font-size {
    font-size: 20px;
}

.menu-day-background {
    background-color: #cbcbcb;
}

.box-sizing {
    width: 100px;
    min-height: 60px;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.w-52 {
    width: 185px;
    width: 185px;
    max-height: 161px;
    overflow: auto;
    overflow-x: hidden;
}

.w-3 {
    width: 60px;
    height: 60px;
}

.hover_font_size {
    font-size: 13px;
    font-weight: bold;
    text-decoration: underline;
}

.title_color {
    color: #f7a53a;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.show-box {
    display: none;
}

.box-type-show:hover .show-box {
    display: block;
}

.absolute-div {
    position: absolute;
    top: 0px;
    left: 50px;
}

.add_food_color {
    background-color: #38558e;
}

.absolute-items {
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: 0px;
    margin: auto;
}

.absolute-items2 {

    position: absolute;
    right: 8px;
    bottom: 8px;
    margin: auto;
}

.text-color-circle-icon {
    color: #38558e;
}

.mh-135 {
    height: 215px;
    padding: 4px;
}

.mh-135>div {
    padding: 4px;
}

.mh-135>div img {
    object-fit: cover;
}

span.option_title {
    line-height: 17px;
    padding-bottom: 10px;
}
</style>
